<template>
    <div
        v-if="itemData"
        class="border p-2 rounded-md flex items-center"
        :class="getAlertClass(item)">
        <div class="flex-1 flex items-center mr-1">
            <div class="flex-none mr-1">
                <hts-icons
                    v-if="alertTypes.includes('danger')"
                    svg="warning-sign"
                    class="inline-block mx-1"
                    color="red" />
                <hts-icons
                    v-if="alertTypes.includes('waiting')"
                    svg="hourglass"
                    fill-color="orange"
                    class="inline-block" />
                <hts-icons
                    v-if="alertTypes.includes('driver')"
                    svg="driver"
                    color="purple"
                    class="inline-block" />
            </div>
            <template v-if="['SCHEDULE_ALERT', 'JOURNEY_PRE_ALERT'].includes(item.type.toString().toUpperCase())">
                <div class="flex-1">
                    <alert-task
                        v-if="itemData.cls === 'task'"
                        :journey="journey"
                        :item="itemData" />
                    <alert-stage
                        v-else-if="itemData.cls === 'stage'"
                        :journey="journey"
                        :item="itemData" />
                    <template v-else>
                        <span v-html="item.message" />
                    </template>
                </div>
            </template>
            <template v-else>
                <div class="flex-1">
                    <span v-html="item.message" />
                </div>
            </template>
        </div>
        <div class="flex-none flex flex-col justify-start items-end">
            <span>
                {{ $formatters.datetime(item.createdAt) }}
            </span>
            <div v-if="false">
                <label class="mr-1 font-medium">
                    Thao tác:
                </label>
                <hts-form-button
                    size="small"
                    color="primary"
                    :outline="false"
                    @click="openModify">
                    {{ $t('labels.planningModify') }}
                </hts-form-button>
                <hts-form-button
                    size="small"
                    :loading="skipping"
                    :outline="false"
                    @click="skipAlert">
                    {{ $t('labels.skip') }}
                </hts-form-button>
            </div>
            <div
                v-if="item.resolved"
                class="flex justify-end items-center">
                <span>
                    Đã điều chỉnh lúc: {{ $formatters.datetime(item.resolvedAt) }}
                </span>
            </div>
            <div
                v-if="item.skipped"
                class="flex justify-end items-center">
                <span>
                    Bỏ qua lúc: {{ $formatters.datetime(item.skippedAt) }}
                </span>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import AlertStage from './alert-components/alert-stage.vue'
import AlertTask from './alert-components/alert-task.vue'
const props = defineProps({
  journey: {
    type: Object as PropType<any>,
    required: true
  },
  item: {
    type: Object,
    required: true
  },
  noAction: Boolean
})
const emits = defineEmits(['modify', 'skipped'])
const { item, journey } = toRefs(props)
const itemData = computed(() => item.value?.data)

const itemType = computed(() => item.value?.type)
const itemDataCls = computed(() => item.value?.data?.cls)
const itemDataType = computed(() => item.value?.data?.type)
const alertTypes = computed(() => {
  if (
    ['DRIVER_GPS_ERROR', 'DRIVER_NOT_ACTION'].includes(itemType.value) ||
    itemDataCls.value === 'driver' ||
    ['C7', 'C8', 'C9', 'GPS'].includes(itemDataType.value)
  ) {
    return ['driver']
  }
  if (['C1', 'C4', 'C5', 'C6'].includes(itemDataType.value)) {
    return ['danger']
  }
  if (['C2', 'C3'].includes(itemDataType.value)) {
    return ['waiting']
  }
  return []
})
const getAlertClass = (alert: any) => {
  if (alert.resolved) {
    return { 'border-slate-400': true, 'text-slate-400': true }
  }
  if (alert.skipped) {
    return { 'border-gray-300': true, 'text-gray-300': true }
  }
  if (alert.data?.type === 'delay') {
    return { 'border-error-400': true, 'text-error-400': true }
  }
  return {
    'border-orange-400': alertTypes.value.includes('waiting'),
    'border-purple-400': alertTypes.value.includes('driver'),
    'border-error-400': alertTypes.value.includes('danger')
  }
}
const openModify = () => {
  emits('modify')
}
const skipping = ref(false)
const skipAlert = () => {
  skipping.value = true
  $api($url.monitoring.alert.scheduleSkip, { uriParams: { ID: journey.value.id, ALERT_ID: item.value?._id } })
    .then((response) => {
      emits('skipped', item.value?._id)
      skipping.value = false
    })
    .catch(() => {
      skipping.value = false
    })
}
</script>
